import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button } from '@gitbook/spine-react';

import type { GlossaryStateActions, GlossaryStateEntry } from './state';

export function GlossaryEntryRow(props: {
    displayedLanguages: api.TranslationLanguage[];
    entry: GlossaryStateEntry;
    actions: GlossaryStateActions;
    editable: boolean;
}) {
    const { displayedLanguages, entry, actions, editable } = props;

    return (
        <div className="group table-row">
            {displayedLanguages.map((language, index) => (
                <div key={language} className="relative table-cell border">
                    <textarea
                        value={entry.translations[language] ?? ''}
                        onChange={(event) => {
                            if (!editable) {
                                return;
                            }

                            // Normalize to remove newlines
                            const value = event.target.value.replace(/\n/g, ' ');

                            actions.updateGlossaryEntry(entry.entryId, {
                                ...entry.translations,
                                [language]: value,
                            });
                        }}
                        placeholder={`${language} translation`}
                        className="w-full resize-none px-4 py-2 text-base text-ui-base"
                        rows={1}
                        readOnly={!editable}
                    />

                    {index === displayedLanguages.length - 1 && editable ? (
                        <div className="-translate-y-1/2 absolute top-1/2 right-0 translate-x-1/2 opacity-0 transition-opacity group-hover:opacity-100">
                            <Button
                                kind="secondary"
                                size="small"
                                label="Delete entry"
                                iconOnly
                                leadingIcon={Icon.Trashcan}
                                onPress={() => {
                                    actions.deleteGlossaryEntry(entry.entryId);
                                }}
                            />
                        </div>
                    ) : null}
                </div>
            ))}
        </div>
    );
}
